import createApiRequest from '@/lib/axios/createApiRequest';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';

export default function deleteOpportunityConfidenceLevel(
  opportunityConfidenceLevelId: string,
  ownerOrgId: string,
) {
  return createApiRequest({
    method: 'delete',
    path: `opportunity-confidence-levels/${opportunityConfidenceLevelId}?${joinNonEmptyParams(
      {
        ownerOrgId,
      },
    )}`,
    throwErrors: true,
  });
}
